import { setActiveCalcValue } from "../../../../calculator";
import { DEF_Y_POS, POSITIONS_MAPS } from "../../../constants";
import { hideAndRemove, showHideChildrenByNames } from "../../../helpers";
import { hideUnnecessaryBolt } from "../../../helpers/hideUnnecessaryBolt";
import { toggleSceneObject, toggleSingleSceneObject } from "../../../togglers";
import { toggleChildByName } from "../../../togglers/toggleChildByName";

export const changePolkaPribornaya = (
    type,
    depth,
    number,
    isChecked,
    preservedY = null,
    preservedVisibleChildren = null,
) => {
    const depthInput = document.querySelector(`input[name="polka_pribornaya_depth_${number}"]:checked`);

    const depthInputValueDSP = depth || depthInput?.value || 300;
    const depthValueMetal = 300;

    const currentDepth = type === "dsp" ? depthInputValueDSP : depthValueMetal;

    const count = 3; // количество уровней полки
    const step = 0.25; // шаг по Y между уровнями
    const maxYDSP = servObj.building.MAX_Y_VALUES.default.max; // макс. Y для DSP
    const maxYMetall = servObj.building.MAX_Y_VALUES.polka_pribornaya__metall.max; // макс. Y для металла
    const maxY = type === "dsp" ? maxYDSP : maxYMetall; // выбираем макс. Y по типу

    // создаём объект с позициями по Y: 1,2,3 => maxY, maxY-step, maxY-2*step
    const position_on_y = Object.fromEntries(Array.from({ length: count }, (_, i) => [i + 1, maxY - i * step]));

    if (preservedY === null) {
        const prevPosition = servObj.activePolkaPribornaya.find(
            (el) => el.userData.inputCount === number && el.userData.type === type,
        );
        preservedY = prevPosition ? prevPosition.position.y : null;
    }

    const allObjects = servObj.allPolkaPribornaya;
    const activeArray = servObj.activePolkaPribornaya;

    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");

    const prefix = isOstrov ? "ostrov__polka_pribornaya" : "polka_pribornaya";
    const name = `${prefix}__${type}__${servObj.tableSize.tableWidth.current}x${currentDepth}`;

    const polkaWithVisibleChildren = servObj.activePolkaPribornaya.find(
        (polka) => polka.userData?.visibleChildren?.length,
    );

    let visibleChildren =
        polkaWithVisibleChildren && polkaWithVisibleChildren?.userData?.inputCount === number
            ? polkaWithVisibleChildren.userData.visibleChildren
            : [];

    preservedVisibleChildren && (visibleChildren = preservedVisibleChildren);

    toggleSceneObject({
        allObjects,
        activeArray,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.inputCount === number && el.userData.type === type) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: {
            y: preservedY ?? position_on_y[number] ?? 12,
        },
        userData: {
            name,
            inputCount: number,
            type,
            depth: currentDepth,
            verticalOnly: true,
            visibleChildren,
        },
        hideChildrenName: ["razdelitel", "ogranichitel", "osveshchenie"],
        ...(isOstrov ? {} : { excludes: ["ostrov"] }), // только если не остров
    });

    if (type === "dsp") {
        const stopsZodnii = document.querySelector(
            `input[name="polka_pribornaya_ogranichiteli_${number}"][value="zadnii"]`,
        );
        const stopsBokovoi = document.querySelector(
            `input[name="polka_pribornaya_ogranichiteli_${number}"][value="bokovoi"]`,
        );

        changePolkaPribornayaStops("zadnii", number, stopsZodnii?.checked);
        changePolkaPribornayaStops("bokovoi", number, stopsBokovoi?.checked);

        const params_wrap = document.querySelector(`.polka_params_${number}`);
        if (params_wrap) {
            params_wrap.classList.toggle("disable", !isChecked);
        }

        if (!isChecked) {
            const depth300 = document.querySelector(`input[name="polka_pribornaya_depth_${number}"][value="300"]`);
            const depth400 = document.querySelector(`input[name="polka_pribornaya_depth_${number}"][value="400"]`);

            if (stopsZodnii) stopsZodnii.checked = false;
            if (stopsBokovoi) stopsBokovoi.checked = false;
            if (depth300) depth300.checked = false;
            if (depth400) depth400.checked = false;

            const stopsBok = isOstrov
                ? `polka_pribornaya_ogranichiteli_ostrov_${servObj.tableSize.tableWidth.current}__${number}`
                : `polka_pribornaya_ogranichiteli_${servObj.tableSize.tableWidth.current}__${number}`;
            const stops300CalcName = isOstrov
                ? `polka_pribornaya_ogranichiteli_ostrov_300__${number}`
                : `polka_pribornaya_ogranichiteli_300__${number}`;
            const stops400CalcName = isOstrov
                ? `polka_pribornaya_ogranichiteli_ostrov_400__${number}`
                : `polka_pribornaya_ogranichiteli_400__${number}`;

            servObj.calc[stopsBok].active = false;
            servObj.calc[stops300CalcName].active = false;
            servObj.calc[stops400CalcName].active = false;

            const razdeliteliWrap = document.querySelector(".razdeliteli_na_pribornuyu_wrap");
            const razdeliteli = razdeliteliWrap?.querySelector("input[name='razdeliteli_pribornaya_amount']");
            const btnPlus = razdeliteliWrap?.querySelector(".btn_plus");
            const btnMinus = razdeliteliWrap?.querySelector(".btn_minus");

            if (polkaWithVisibleChildren && polkaWithVisibleChildren?.userData?.inputCount === number && razdeliteli) {
                razdeliteli.value = 0;
                btnPlus.classList.remove("disable");
                btnMinus.classList.add("disable");
                razdeliteli.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }
    }

    const osveshchenieDepth = document.querySelector('input[name="osveshchenie_pod_pribornuyu"]:checked');
    if (osveshchenieDepth) changeOsveshcheniePodPribornuyu(osveshchenieDepth.value, true);

    if (isOstrov) {
        const osveshchenieDepthBack = document.querySelector(
            'input[name="osveshchenie_pod_pribornuyu__table_back"]:checked',
        );
        const osveshchenieDepthFront = document.querySelector(
            'input[name="osveshchenie_pod_pribornuyu__table_front"]:checked',
        );
        if (osveshchenieDepthBack) changeOsveshcheniePodPribornuyu(osveshchenieDepthBack.value, true, "back");
        if (osveshchenieDepthFront) changeOsveshcheniePodPribornuyu(osveshchenieDepthFront.value, true, "front");
    }

    const polkaDepthInput = document.querySelector(
        `input[name="polka_pribornaya_depth_${number}"][value="${depth || 300}"]`,
    );
    if (isChecked && polkaDepthInput && type !== "metall") {
        polkaDepthInput.checked = true;
    }

    servObj.building._dragControls.objects = [...servObj.building._all, ...servObj.activePolkaPribornaya];
};
export const changePolkaPribornayaStops = (value, number, isChecked) => {
    ("ogranichitel_bokovoi__polka__1200x400");
    ("ogranichitel_zadnii__polka__1200x400");

    if (servObj.activePolkaPribornaya.length) {
        const targerObj = servObj.activePolkaPribornaya.find(
            (el) => el.userData.inputCount === number && el.userData.type === "dsp",
        );
        if (!targerObj) return;

        targerObj && showHideChildrenByNames(targerObj, [value], isChecked);
        if (isChecked) targerObj.userData.visibleChildren.push(value);
        if (!isChecked)
            targerObj.userData.visibleChildren = targerObj.userData.visibleChildren.filter((el) => el !== value);
    }
};
export const changeOsveshchenieVerkhnee = (position, isChecked, preservedY = null) => {
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const prefix = isOstrov ? "ostrov__osveshchenie_verkhnee" : "osveshchenie_verkhnee";
    const name = `${prefix}__${position}_tip__${servObj.tableSize.tableWidth.current}`;

    const visibleChildren = servObj.activeOsveshchenieVerkhnee.length
        ? servObj.activeOsveshchenieVerkhnee?.[0]?.userData?.visibleChildren
        : [];

    toggleSingleSceneObject({
        allObjects: servObj.allOsveshchenieVerkhnee,
        activeArray: servObj.activeOsveshchenieVerkhnee,
        name,
        isChecked,
        filterActiveFn: () => {},
        position: {
            y: preservedY ?? servObj.building.MAX_Y_VALUES.osveshchenie_verkhnee.max,
        },
        userData: { name, type: position, verticalOnly: true, visibleChildren },
        hideChildrenName: ["instrumentalnaya_planka"],
        ...(isOstrov ? {} : { excludes: ["ostrov"] }),
    });

    const wrapInstrumentalnayaPlanka = document.getElementById("wrap_instrumentalnaya_planka");
    wrapInstrumentalnayaPlanka.classList.toggle("disable", !isChecked);

    const derzhatelChecked = !!document.querySelector("input[name='derzhatel_ruchnogo_instrumenta']")?.checked;
    changeDerzhatelRuchnogoInstrumenta(derzhatelChecked);
};
export const changeOsveshcheniePodPribornuyu = (size, isChecked, placement = null) => {
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const tempName = "osveshchenie_pod_pribornuyu_polku";
    const name = isOstrov ? `${tempName}__${size}__${placement}` : `${tempName}__${size}`;
    const elName = isOstrov ? "ostrov__polka_pribornaya__dsp" : "polka_pribornaya__dsp";

    const polki = servObj.activePolkaPribornaya
        .filter((el) => el.name.includes(elName))
        .sort((a, b) => a.position.y - b.position.y);

    if (!polki.length) return;

    // 1️⃣ Удаляем освещение той же стороны (placement) со всех полок
    polki.forEach((el) => {
        const sameSideLights = el.userData.visibleChildren.filter((childName) =>
            isOstrov
                ? childName.startsWith(`${tempName}__`) && childName.endsWith(`__${placement}`)
                : childName.startsWith(`${tempName}__`),
        );

        if (sameSideLights.length > 0) {
            showHideChildrenByNames(el, sameSideLights, false);
            el.userData.visibleChildren = el.userData.visibleChildren.filter(
                (childName) => !sameSideLights.includes(childName),
            );
        }
    });

    // 2️⃣ Добавляем / удаляем освещение только у нижней полки
    const targetPolka = polki[0];

    if (isChecked) {
        // Добавляем новое освещение на нижнюю полку
        if (!targetPolka.userData.visibleChildren.includes(name)) {
            targetPolka.userData.visibleChildren.push(name);
        }
        showHideChildrenByNames(targetPolka, [name], true);
    } else {
        // Убираем конкретное освещение
        showHideChildrenByNames(targetPolka, [name], false);
        targetPolka.userData.visibleChildren = targetPolka.userData.visibleChildren.filter(
            (childName) => childName !== name,
        );
    }
};

export const changeOsveshchenieBokovoe = (side, isChecked, preservedY = null, placement = null) => {
    if (!side) {
        console.warn("Не передано значение для изменения боковое освещения:", side);
        return;
    }

    const name = `osveshchenie_bokovoe__${side}`;

    const matchesParams = (el) => el.userData.side === side && el.userData.placement === placement;

    toggleSceneObject({
        allObjects: servObj.allOsveshchenieBokovoe,
        activeArray: servObj.activeOsveshchenieBokovoe,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (matchesParams(el)) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: {
            y: preservedY ?? DEF_Y_POS.FULL_WIDTH,
            x: POSITIONS_MAPS.upPositionMapPos[side].x[servObj.tableSize.tableWidth.current],
        },
        userData: { name, side, verticalOnly: true, placement },
    });

    isChecked &&
        hideUnnecessaryBolt({
            activeArray: servObj.activeOsveshchenieBokovoe,
            findFn: matchesParams,
        });
};
export const changePerfopanel = (value, isChecked, preservedY = null) => {
    const isFullWidth = value !== "left" && value !== "right";

    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const isSMK = servObj.redactorModeObject.name.includes("smk");

    const width = isFullWidth ? servObj.tableSize.tableWidth.current : servObj.tableSize.tableWidth.current / 2;
    const prefix = isOstrov ? "ostrov__perfopanel" : "perfopanel";
    const name = isFullWidth ? `${prefix}__${width}x${value}` : `${prefix}__${value}__${width}x325`;

    const perf_def_pos = name.includes("325") ? DEF_Y_POS.HALF_WIDTH : DEF_Y_POS.FULL_WIDTH;
    const yPos = isSMK ? 9.96 : perf_def_pos;

    if (isFullWidth) {
        toggleSceneObject({
            allObjects: servObj.allPerfopanel,
            activeArray: servObj.activePerfopanel,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (
                    el.name.includes(`perfopanel__${width}x`) &&
                    !el.name.includes("left") &&
                    !el.name.includes("right")
                ) {
                    hideAndRemove(el); // Удаляем объект со сцены
                    return false; // Исключаем из массива
                }
                return true;
            },
            position: {
                y: preservedY ?? yPos,
            },
            userData: { name, type: value, value, verticalOnly: true },
            hideChildrenName: ["hitbox"],
            excludes: isOstrov ? ["verstak"] : ["verstak", "ostrov"],
        });
    } else {
        toggleSceneObject({
            allObjects: servObj.allPerfopanel,
            activeArray: servObj.activePerfopanel,
            name,
            isChecked,
            filterActiveFn: (el) => {
                if (el.userData.value === value) {
                    hideAndRemove(el); // Удаляем объект со сцены
                    return false; // Исключаем из массива
                }
                return true;
            },
            position: { y: preservedY ?? perf_def_pos },
            userData: { name, type: value, value, width, verticalOnly: true },
            hideChildrenName: ["hitbox"],
        });
    }
};
export const changePanelElektromontazhnaya = (side = null, isChecked) => {
    const isOstrov = servObj.redactorModeObject?.name.includes("ostrov");
    const isVerstakCategory = servObj.redactorModeObject.userData.loadData.folderName === "verstaki";

    const width = side ? servObj.tableSize.tableWidth.current / 2 : servObj.tableSize.tableWidth.current;
    let prefix = "panel_elektromontazhnaya";
    if (isOstrov) {
        prefix = "ostrov__panel_elektromontazhnaya";
    }
    if (isVerstakCategory) {
        prefix = "verstak__vs__panel_elektromontazhnaya";
    }
    const name = side ? `${prefix}__${side}__${width}` : `${prefix}__${width}`;
    const yPos = 10;
    const position =
        side === "right"
            ? { y: yPos, x: POSITIONS_MAPS.panelElektromontazhnayaMapPos[side].x[servObj.tableSize.tableWidth.current] }
            : { y: yPos };

    const excludes = isOstrov || isVerstakCategory ? [] : ["ostrov", "verstak"];

    toggleSceneObject({
        allObjects: servObj.allPanelElektromontazhnaya,
        activeArray: servObj.activePanelElektromontazhnaya,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.side === side) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position,
        userData: { name, type: side, side, width, position: "top" },
        excludes,
    });

    const fullWidthBlock = document.getElementById("full_width");
    const halfWidthBlock = document.getElementById("half_width");
    const fullWidthMultidrop = fullWidthBlock.querySelector(".multidrop");
    const leftMultidrop = halfWidthBlock?.querySelector(".multidrop.panel_elektromontazhnaya__left");
    const rightMultidrop = halfWidthBlock?.querySelector(".multidrop.panel_elektromontazhnaya__right");

    switch (side) {
        case "left":
            // halfWidthBlock.querySelector("#left__amount_sockets").checked = isChecked;
            leftMultidrop?.classList.toggle("disable", !isChecked);
            if (!isChecked) {
                document.querySelector('input[name="left__amount_sockets__count"').value = 4;
                const wrapper = leftMultidrop?.querySelector(".multidrop__menu");
                const checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach((checkbox) => {
                    checkbox.checked = false;
                });
            }
            break;

        case "right":
            // halfWidthBlock.querySelector("#right__amount_sockets").checked = isChecked;
            rightMultidrop?.classList.toggle("disable", !isChecked);
            if (!isChecked) {
                document.querySelector('input[name="right__amount_sockets__count"').value = 4;
                const wrapper = rightMultidrop?.querySelector(".multidrop__menu");
                const checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach((checkbox) => {
                    checkbox.checked = false;
                });
            }
            break;
        case null:
            // fullWidthBlock.querySelector("#full_width__amount_sockets").checked = isChecked;
            fullWidthMultidrop?.classList.toggle("disable", !isChecked);
            if (!isChecked) {
                document.querySelector('input[name="full_width__amount_sockets__count"').value = 4;

                const wrapper = document.querySelector(".multidrop__menu");
                const checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');

                checkboxes.forEach((checkbox) => {
                    checkbox.checked = false;
                });
            }
            break;
        default:
            break;
    }
};
export const changeLotokMetallicheskii = (side = null, isChecked, preservedY = null) => {
    const width = side ? servObj.tableSize.tableWidth.current / 2 : servObj.tableSize.tableWidth.current;
    const name = side ? `lotok_metallicheskii__${side}__${width}` : `lotok_metallicheskii__${width}`;

    toggleSceneObject({
        allObjects: servObj.allLotokMetallicheskii,
        activeArray: servObj.activeLotokMetallicheskii,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.side === side) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: { y: preservedY ?? DEF_Y_POS.HALF_WIDTH },
        userData: { name, type: side, side, width, verticalOnly: true },
        hideChildrenName: ["hitbox"],
    });
};
export const changePlankaDlyaLotkov = (side = null, isChecked, preservedY = null) => {
    const isOstrov = servObj.redactorModeObject?.name.includes("ostrov");
    const isSMK = servObj.redactorModeObject?.name.includes("smk");

    const width = side ? servObj.tableSize.tableWidth.current / 2 : servObj.tableSize.tableWidth.current;
    const prefix = isOstrov ? "ostrov__planka_dlya_lotkov" : "planka_dlya_lotkov";
    const name = side ? `${prefix}__${side}__${width}` : `${prefix}__${width}`;

    const yPos = isSMK ? 10 : (preservedY ?? DEF_Y_POS.HALF_WIDTH);

    toggleSceneObject({
        allObjects: servObj.allPlankaDlyaLotkov,
        activeArray: servObj.activePlankaDlyaLotkov,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.side === side) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: { y: yPos },
        userData: { name, type: side, side, width, verticalOnly: true },
        ...(isOstrov ? {} : { excludes: ["ostrov"] }),
    });
};
export const changePolkaKorotkaya = (side, depth, isChecked, preservedY) => {
    const tableWidth = servObj.tableSize.tableWidth.current;
    const name = `polka_korotkaya__${side}__${tableWidth / 2}x${depth}`;

    const prevPosition = servObj.activePolkaKorotkaya.find((el) => el.userData.side === side);
    preservedY = prevPosition ? prevPosition.position.y : null;

    toggleSceneObject({
        allObjects: servObj.allPolkaKorotkaya,
        activeArray: servObj.activePolkaKorotkaya,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.side === side) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: { y: preservedY ?? DEF_Y_POS.HALF_WIDTH },
        userData: { name, type: side, side, depth, verticalOnly: true },
    });
};
export const changePolkaNaklonnaya = (side, isChecked, preservedY) => {
    const tableWidth = servObj.tableSize.tableWidth.current;
    const name = `polka_naklonnaya__${side}__${tableWidth / 2}x300`;

    toggleSceneObject({
        allObjects: servObj.allPolkaNaklonnaya,
        activeArray: servObj.activePolkaNaklonnaya,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.side === side) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: { y: preservedY ?? DEF_Y_POS.HALF_WIDTH },
        userData: { name, type: side, side, verticalOnly: true },
    });
};
export const changeRamaRazdelitelnaya = (isChecked) => {
    const tempName = "rama_razdelitelnaya";
    const name = `${tempName}__${servObj.tableSize.tableWidth.current}`;

    const isVerstakCategory = servObj.redactorModeObject.userData.loadData.folderName === "verstaki";

    const tableWidth = servObj.tableSize.tableWidth.current;
    const calc_name = `${tempName}__${tableWidth}`;
    setActiveCalcValue(calc_name, isChecked);

    toggleSingleSceneObject({
        allObjects: servObj.allRamaRazdelitelnaya,
        activeArray: servObj.activeRamaRazdelitelnaya,
        name,
        isChecked,
        filterActiveFn: (el) => el.name.includes(name),
        position: {
            y: isVerstakCategory ? 11.138 : 11.205,
        },
    });
};
export const changeDerzhatelMonitora = (value, isChecked, targetSide = null, preservedY = null, placement = null) => {
    const sideInput =
        Array.from(
            document.querySelectorAll(
                `input[name="derzhatel_monitora__side${placement ? "__table_" + placement : ""}"]:checked`,
            ),
        ) || [];
    let selectedSide = sideInput.map((el) => el.value);
    if (!selectedSide.length) selectedSide = ["left"];

    const isSMK = servObj.redactorModeObject.name.includes("smk");
    const isKSM = servObj.redactorModeObject.name.includes("ksm");
    const yPos = isSMK ? 10.085 : (preservedY ?? (isKSM ? 11.44 : DEF_Y_POS.FULL_WIDTH));

    selectedSide.forEach((el) => {
        const side = targetSide || el || "left";
        const tempName = "derzhatel_monitora";
        const amount = value === "1" ? `${value}_richag` : `${value}_richaga`;

        const name = `${isSMK ? "smk__" : ""}${tempName}__${side}__${amount}`;

        const matchesParams = (el) => el.userData.side === side && el.userData.placement === placement;

        const xPos = isSMK
            ? POSITIONS_MAPS.derzhatelMonitoraSMK[side].x[servObj.tableSize.tableWidth.current]
            : POSITIONS_MAPS.upPositionMapPos[side].x[servObj.tableSize.tableWidth.current];

        toggleSceneObject({
            allObjects: servObj.allDerzhatelMonitora,
            activeArray: servObj.activeDerzhatelMonitora,
            filterActiveFn: (el) => {
                if (matchesParams(el)) {
                    hideAndRemove(el); // Удаляем объект со сцены
                    return false; // Исключаем из массива
                }
                return true;
            },
            name,
            isChecked,
            valueType: `${tempName}__${side}`,
            position: {
                y: yPos,
                x: xPos,
            },
            userData: { name, side, amount: value, verticalOnly: true, placement },
            ...(isSMK ? {} : { excludes: ["smk__"] }),
        });

        isChecked &&
            hideUnnecessaryBolt({
                activeArray: servObj.activeDerzhatelMonitora,
                findFn: matchesParams,
            });
    });
};
export const changeDerzhatelMonitoraSide = (side, isChecked, preservedY = null, placement = null) => {
    const value =
        document.querySelector(
            `input[name="derzhatel_monitora__amount${placement ? "__table_" + placement : ""}"]:checked`,
        )?.value || "1";
    if (!value) return;

    const isSMK = servObj.redactorModeObject.name.includes("smk");
    const isKSM = servObj.redactorModeObject.name.includes("ksm");

    const tempName = "derzhatel_monitora";
    const amount = value === "1" ? `${value}_richag` : `${value}_richaga`;
    const name = `${isSMK ? "smk__" : ""}${tempName}__${side}__${amount}`;

    const yPos = isSMK ? 10.085 : (preservedY ?? (isKSM ? 11.44 : DEF_Y_POS.FULL_WIDTH));
    const xPos = isSMK
        ? POSITIONS_MAPS.derzhatelMonitoraSMK[side].x[servObj.tableSize.tableWidth.current]
        : POSITIONS_MAPS.upPositionMapPos[side].x[servObj.tableSize.tableWidth.current];

    const matchesParams = (el) => el.userData.side === side && el.userData.placement === placement;

    toggleSceneObject({
        allObjects: servObj.allDerzhatelMonitora,
        activeArray: servObj.activeDerzhatelMonitora,
        filterActiveFn: (el) => {
            if (matchesParams(el)) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        name,
        isChecked,
        valueType: side,
        position: {
            y: yPos,
            x: xPos,
        },
        userData: { name, side, amount, verticalOnly: true, placement },
        ...(isSMK ? {} : { excludes: ["smk__"] }),
    });

    isChecked &&
        hideUnnecessaryBolt({
            activeArray: servObj.activeDerzhatelMonitora,
            findFn: matchesParams,
        });
};
export const changeElektropanel = (isChecked, placement = null) => {
    const name = "elektropanel";
    const object = servObj.redactorModeObject;
    const tableName = object.name.split("__")[0];

    const isVerstakCategory = object.userData.loadData.folderName === "verstaki";

    const map = {
        otsinkovka: 10.004,
        metall_2: 10.003,
        metall_6: 10.007,
    };

    const names = servObj.activeTableCover.map((el) => el.name);
    const found = Object.entries(map).find(([key]) => names.some((n) => n.includes(key)));
    let yPos = found ? found[1] : 10;

    if (isVerstakCategory) yPos -= 0.069;

    const posMap = {
        smk: {
            x: 0.15,
            y: 9.9405,
        },
        default: { y: yPos },
    };
    const position = posMap[tableName] ?? posMap.default;

    toggleSceneObject({
        allObjects: servObj.allElektropanel,
        activeArray: servObj.activeElektropanel,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.placement === placement) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position,
        userData: { placement },
    });
};
export const changePolkaDlyaKlaviaturiIMishi = (side, isChecked, preservedY = null, placement = null) => {
    const tempName = "polka_dlya_klaviaturi_i_mishi";
    const name = `${tempName}__${side}`;

    const matchesParams = (el) => el.userData.side === side && el.userData.placement === placement;

    toggleSceneObject({
        allObjects: servObj.allPolkaDlyaKlaviaturiIMishi,
        activeArray: servObj.activePolkaDlyaKlaviaturiIMishi,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (matchesParams(el)) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: {
            y: preservedY ?? 11.24,
            x: POSITIONS_MAPS.polkaDlyaKlavIMishiMapPos[side].x[servObj.tableSize.tableWidth.current],
        },
        userData: { name, side, verticalOnly: true, position: "top", placement },
    });

    isChecked &&
        hideUnnecessaryBolt({
            activeArray: servObj.activePolkaDlyaKlaviaturiIMishi,
            findFn: matchesParams,
        });
};
export const changeKronshteinDlyaPrintera = (side, isChecked, preservedY = null, placement = null) => {
    const tempName = "kronshtein_dlya_printera";
    const name = `${tempName}__${side}`;

    const matchesParams = (el) => el.userData.side === side && el.userData.placement === placement;

    toggleSceneObject({
        allObjects: servObj.allKronshteinDlyaPrintera,
        activeArray: servObj.activeKronshteinDlyaPrintera,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (matchesParams(el)) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: {
            y: preservedY ?? DEF_Y_POS.FULL_WIDTH,
            x: POSITIONS_MAPS.upPositionMapPos[side].x[servObj.tableSize.tableWidth.current],
        },
        userData: { name, side, verticalOnly: true, placement },
    });

    isChecked &&
        hideUnnecessaryBolt({
            activeArray: servObj.activeKronshteinDlyaPrintera,
            findFn: matchesParams,
        });
};
export const changePodstavkaDlyaChertezhei = (side, isChecked, preservedY = null, placement = null) => {
    const tempName = "podstavka_dlya_chertezhei";
    const name = `${tempName}__${side}`;

    const matchesParams = (el) => el.userData.side === side && el.userData.placement === placement;

    toggleSceneObject({
        allObjects: servObj.allPodstavkaDlyaChertezhei,
        activeArray: servObj.activePodstavkaDlyaChertezhei,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (matchesParams(el)) {
                hideAndRemove(el); // Удаляем объект со сцены
                return false; // Исключаем из массива
            }
            return true;
        },
        position: {
            y: preservedY ?? DEF_Y_POS.FULL_WIDTH,
            x: POSITIONS_MAPS.upPositionMapPos[side].x[servObj.tableSize.tableWidth.current],
        },
        userData: { name, side, verticalOnly: true, placement },
    });

    isChecked &&
        hideUnnecessaryBolt({
            activeArray: servObj.activePodstavkaDlyaChertezhei,
            findFn: matchesParams,
        });
};
export const changeInstrumentalnayaPlanka = (isChecked) => {
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");
    const tempName = isOstrov ? "ostrov__instrumentalnaya_planka" : "instrumentalnaya_planka";

    const targerObj = servObj.activeOsveshchenieVerkhnee[0];
    if (servObj.activeOsveshchenieVerkhnee.length) {
        if (isChecked) {
            targerObj.userData.visibleChildren.push(tempName);
            showHideChildrenByNames(targerObj, [tempName], true);
        }
        if (!isChecked) {
            targerObj.userData.visibleChildren = targerObj.userData.visibleChildren.filter((el) => el !== tempName);
            showHideChildrenByNames(targerObj, [tempName], false);
        }
    }
    if (targerObj) {
        const instrumentalnayaPlanka = targerObj.children?.filter((el) =>
            el.name.includes("instrumentalnaya_planka"),
        )[0];
        showHideChildrenByNames(instrumentalnayaPlanka, ["derzhatel_ruchnogo_instrumenta"], false);
    }
};
export const changeDerzhatelRuchnogoInstrumenta = (isChecked, placement = null) => {
    const osveshchenie = servObj.activeOsveshchenieVerkhnee[0];
    if (!osveshchenie) return;

    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");

    const instrumentalnayaPlanka = osveshchenie.children.filter((el) => el.name.includes("instrumentalnaya_planka"));
    const hideChildrenName = isOstrov
        ? `ostrov__derzhatel_ruchnogo_instrumenta__${placement}`
        : "derzhatel_ruchnogo_instrumenta";

    if (instrumentalnayaPlanka.length) {
        const targerObj = instrumentalnayaPlanka[0];
        targerObj.userData.visibleChildren = [];
        if (isChecked) {
            targerObj.userData.visibleChildren.push(hideChildrenName);
            osveshchenie.userData.visibleChildren.push(hideChildrenName);
            showHideChildrenByNames(targerObj, [hideChildrenName], true);
        }
        if (!isChecked) {
            targerObj.userData.visibleChildren = targerObj.userData.visibleChildren.filter(
                (el) => el !== hideChildrenName,
            );
            osveshchenie.userData.visibleChildren = osveshchenie.userData.visibleChildren.filter(
                (el) => el !== hideChildrenName,
            );
            showHideChildrenByNames(targerObj, [hideChildrenName], false);
        }
    }
};
export const changeRazdeliteliUp = (count) => {
    const name = "razdelitel__polka_pribornaya__dsp";
    const elName = "polka_pribornaya__dsp";
    const polkaPribornaya = servObj.activePolkaPribornaya
        .filter((el) => el.name.includes(elName))
        .sort((a, b) => b.position.y - a.position.y);

    const filterFn = (el) => el !== name;

    if (polkaPribornaya.length) {
        if (count < 5) {
            polkaPribornaya.forEach((el) => {
                showHideChildrenByNames(el, [name], false);
                el.userData.visibleChildren = el.userData.visibleChildren.filter(filterFn);
            });
        } else {
            polkaPribornaya.forEach((el) => {
                showHideChildrenByNames(el, [name], false);
                el.userData.visibleChildren = el.userData.visibleChildren.filter(filterFn);
            });
            polkaPribornaya[0].userData.visibleChildren.push(name);
            showHideChildrenByNames(polkaPribornaya[0], [name], true);
        }
    }
};
export const changeDerzhatelRulonaUp = ({
    isChecked,
    inputCount,
    isHalfObj = false,
    side = null,
    preservedY = null,
} = {}) => {
    const width = servObj.tableSize.tableWidth.current / (isHalfObj ? 2 : 1);
    const name = isHalfObj ? `derzhatel_rulona__verkhnii__${width}__${side}` : `derzhatel_rulona__verkhnii__${width}`;

    const getDefaultY = () => {
        if (isHalfObj) {
            return DEF_Y_POS.HALF_WIDTH;
        } else {
            // арифметическая прогрессия, чтобы каждый последующий держатель был на 0.2 ниже предыдущего
            return 11.9 - (inputCount - 1) * 0.2;
        }
    };

    const position = { y: preservedY ?? getDefaultY() };

    const currentActive = servObj.activeDerzhatelRulonaVerkhnii.find(
        (el) => el.userData.inputCount === inputCount && el.userData.side === side,
    );
    const visibleChildren = currentActive?.userData?.visibleChildren ?? [];

    toggleSceneObject({
        allObjects: servObj.allDerzhatelRulonaVerkhnii,
        activeArray: servObj.activeDerzhatelRulonaVerkhnii,
        name,
        isChecked,
        filterActiveFn: (el) => {
            const match = isHalfObj ? el.userData.side === side : el.userData.inputCount === inputCount;
            if (match) {
                hideAndRemove(el);
                return false;
            }
            return true;
        },
        position,
        userData: {
            name,
            inputCount,
            side,
            width,
            isHalfObj,
            verticalOnly: true,
            visibleChildren,
        },
        hideChildrenName: ["hitbox", "bokovie_fiksatori"],
    });
};
export const changeBokovieFiksatoriUp = ({ isChecked, inputCount, isHalfObj, side } = {}) => {
    const holder = isHalfObj
        ? servObj.activeDerzhatelRulonaVerkhnii.find((el) => el.userData.side === side)
        : servObj.activeDerzhatelRulonaVerkhnii.find((el) => el.userData.inputCount === inputCount);

    if (!holder) {
        console.warn(`Держатель рулона с inputCount = ${inputCount} не найден!`);
        return;
    }

    const width = isHalfObj ? servObj.tableSize.tableWidth.current / 2 : servObj.tableSize.tableWidth.current;
    const name = `bokovie_fiksatori_rulona__${width}`;

    const visibleChildren = holder.userData.visibleChildren;

    if (isChecked && !visibleChildren.includes(name)) {
        visibleChildren.push(name);
    }
    if (!isChecked) {
        holder.userData.visibleChildren = visibleChildren.filter((el) => el !== name);
    }

    showHideChildrenByNames(holder, [name], isChecked);
};
export const changeFiksatorRulonnikhMaterialov = ({
    isChecked,
    isHalfObj = false,
    side = null,
    preservedY = null,
} = {}) => {
    const width = servObj.tableSize.tableWidth.current / (isHalfObj ? 2 : 1);
    const name = isHalfObj
        ? `fiksator_rulonnikh_materialov__${width}__${side}`
        : `fiksator_rulonnikh_materialov__${width}`;

    const position = { y: preservedY ?? DEF_Y_POS.HALF_WIDTH };

    toggleSceneObject({
        allObjects: servObj.allFiksatorRulonnikhMaterialov,
        activeArray: servObj.activeFiksatorRulonnikhMaterialov,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.side === side) {
                hideAndRemove(el);
                return false;
            }
            return true;
        },
        position,
        userData: {
            name,
            side,
            width,
            isHalfObj,
            verticalOnly: true,
        },
        hideChildrenName: ["hitbox", "bokovie_fiksatori"],
    });
};
export const changeDerzhatelRulonaBokovoi = (isChecked, side, visibleChildren = []) => {
    const tableDepth = servObj.tableSize.tableDepth.current;
    const tableWidth = servObj.tableSize.tableWidth.current;
    const name = `derzhatel_rulona__bokovoi__${tableDepth}__${side}`;

    toggleSceneObject({
        allObjects: servObj.allDerzhatelRulonaBokovoi,
        activeArray: servObj.activeDerzhatelRulonaBokovoi,
        name,
        isChecked,
        filterActiveFn: (el) => {
            if (el.userData.side === side) {
                hideAndRemove(el);
                return false;
            }
            return true;
        },
        position: {
            y: 10,
            x: POSITIONS_MAPS.derzhatelRulonaBokovoiMapPos[side].x[tableWidth],
        },
        userData: { visibleChildren, side, name },
        hideChildrenName: ["bokovie_fiksatori"],
    });
};
export const changeBokovieFiksatoriRulonaBokovoi = (isChecked, side) => {
    const holder = servObj.activeDerzhatelRulonaBokovoi.find((el) => el.userData.side === side);
    if (!holder) {
        console.warn(`Держатель рулона с side = ${side} не найден!`);
        return;
    }

    const name = `bokovie_fiksatori`;
    const visibleChildren = holder.userData.visibleChildren;

    const filterArray = () => {
        holder.userData.visibleChildren = visibleChildren.filter((el) => !el.includes(name));
    };

    if (isChecked) {
        filterArray();
        holder.userData.visibleChildren.push(name);
    } else {
        filterArray();
    }

    showHideChildrenByNames(holder, [name], isChecked);
};
export const changeRezakRulonnikhMaterialov = (isChecked, size) => {
    const tableWidth = servObj.tableSize.tableWidth.current;

    const rezak1500 = document.querySelector('input[name="rezak__size"][value="1500"]');
    const rezak1800 = document.querySelector('input[name="rezak__size"][value="1800"]');
    const rezak2000 = document.querySelector('input[name="rezak__size"][value="2000"]');
    const disable1500 = tableWidth < 1500;
    const disable1800 = tableWidth < 1800;
    const disable2000 = tableWidth < 2000;
    rezak1500?.parentNode.classList.toggle("disable", disable1500);
    rezak1800?.parentNode.classList.toggle("disable", disable1800);
    rezak2000?.parentNode.classList.toggle("disable", disable2000);

    const name = `rezak_rulonnikh_materialov__${size}`;

    toggleSingleSceneObject({
        allObjects: servObj.allRezakRulonnikhMaterialov,
        activeArray: servObj.activeRezakRulonnikhMaterialov,
        name,
        isChecked,
        position: { y: 10 },
        userData: { size, name },
    });
};
export const changePolkaPribornayaKSM = (preservedY = null, visibleChildren = []) => {
    const tableWidth = servObj.tableSize.tableWidth.current;
    const name = `ksm__polka__${tableWidth}x600`;

    toggleSingleSceneObject({
        allObjects: servObj.allPolkaPribornayaKSM,
        activeArray: servObj.activePolkaPribornayaKSM,
        name,
        isChecked: true,
        position: { y: preservedY ?? 10 },
        userData: { verticalOnly: true, name, visibleChildren },
        hideChildrenName: ["ogranichitel"],
    });
};
export const changeOgranichiteliUpKSM = (isChecked, type) => {
    const name = `ogranichitel_${type}`;
    const polka = servObj.activePolkaPribornayaKSM[0];

    if (!polka) {
        console.error("[changeOgranichiteliUpKSM]: В массиве servObj.activePolkaPribornayaKSM нет ни одного объекта!");
        return;
    }

    // Создадим поле visibleChildren, если его нет
    if (!polka.userData.visibleChildren) polka.userData.visibleChildren = [];

    const filterFn = (el) => !el.includes(name);

    if (!isChecked) {
        showHideChildrenByNames(polka, [name], false);
        polka.userData.visibleChildren = polka.userData.visibleChildren.filter(filterFn);
    } else {
        showHideChildrenByNames(polka, [name], false);
        polka.userData.visibleChildren = polka.userData.visibleChildren.filter(filterFn);

        polka.userData.visibleChildren.push(name);
        showHideChildrenByNames(polka, [name], true);
    }
};
export const changePerfopanelKSM = (preservedY = null) => {
    const tableWidth = servObj.tableSize.tableWidth.current;
    const name = `ksm__perfopanel__${tableWidth}x600`;
    toggleSingleSceneObject({
        allObjects: servObj.allPerfopanelKSM,
        activeArray: servObj.activePerfopanelKSM,
        name,
        isChecked: true,
        position: { y: preservedY ?? 10 },
        userData: { verticalOnly: true, name, visibleChildren: [] },
    });
};
export const changeRazdeliteliSMK = (count, isUpdateTableDependences = false) => {
    const activePolka = servObj.activePolkaPribornayaSMK[0];
    const visibleChildren = activePolka.userData.visibleChildren;
    const hasRazdeliteli = visibleChildren.some((str) => str.includes("razdelitel"));

    const isChecked = count >= 5;
    const shouldRun = !(isChecked && hasRazdeliteli) || isUpdateTableDependences;

    if (!shouldRun) return;

    const name = `razdelitel`;

    toggleChildByName(name, isChecked, activePolka);
};
export const changeOsveshcheniePodPolkuSMK = (size, isChecked) => {
    const name = `osveshchenie_pod_pribornuyu_polku`;

    const activePolka = servObj.activePolkaPribornayaSMK[0];

    toggleChildByName(name, isChecked, activePolka);
};
export const changePolkaPribornayaSMK = (preservedY = null, visibleChildren = []) => {
    const tableWidth = servObj.tableSize.tableWidth.current;
    const name = `smk__polka_pribornaya__dsp__${tableWidth}x700`;

    toggleSingleSceneObject({
        allObjects: servObj.allPolkaPribornayaSMK,
        activeArray: servObj.activePolkaPribornayaSMK,
        name,
        isChecked: true,
        position: { y: preservedY ?? 10 },
        userData: { verticalOnly: true, name, visibleChildren },
        hideChildrenName: ["razdelitel", "osveshchenie"],
    });
};
